import React from 'react';
import Link from 'next/link';
import { ArrowIcon } from '@avila-tek/ui/src';
import { Category } from '../../../models';

interface CatalogueRowTitleProps {
  category: Category;
}

function CatalogueRowTitle({ category }: CatalogueRowTitleProps) {
  return (
    <div className="flex flex-col sm:flex-row gap-5 items-center">
      <div>
        <h4 className="fontFamily-arial text-2xl font-semibold text-neutral-700">
          {category.name}
        </h4>{' '}
      </div>
      <div className="mt-1">
        <Link href={`/app/catalogue/category/${category._id}`}>
          <button
            type="button"
            className="flex arial items-center text-purple-300 "
          >
            Explorar todos <ArrowIcon className="w-3 h-3 mt-[0.23rem] ml-2" />
          </button>
        </Link>
      </div>
    </div>
  );
}

export default CatalogueRowTitle;
